/**
 * The site's configuration, fetched once from `/config.json`.
 *
 * The bundle is the same in every environment; what differs (the API's
 * address and key, the Events API hosts, the environment's name) is written
 * beside it at deploy time by the serving stack, and by the local server in
 * development. Reading it at runtime is what keeps one build honest for both.
 */
export interface SiteConfig {
  readonly environment: string;
  readonly graphqlUrl: string;
  readonly apiKey: string;
  readonly eventsHttpDns: string;
  readonly eventsRealtimeDns: string;
  readonly identifierBase: string;
}

let loaded: Promise<SiteConfig> | undefined;

export const loadConfig = (): Promise<SiteConfig> => {
  loaded ??= fetch('/config.json').then(async (response) => {
    if (!response.ok) {
      throw new Error(`config.json answered ${response.status}`);
    }
    return (await response.json()) as SiteConfig;
  });
  return loaded;
};
